module.exports = __webpack_public_path__ + "img/marker_jobs.f69266ce.svg";